import { render, staticRenderFns } from "./minichallenge-fandom-autocomplete.vue?vue&type=template&id=e96db504&scoped=true"
import script from "./minichallenge-fandom-autocomplete.vue?vue&type=script&lang=js"
export * from "./minichallenge-fandom-autocomplete.vue?vue&type=script&lang=js"
import style0 from "./minichallenge-fandom-autocomplete.vue?vue&type=style&index=0&id=e96db504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96db504",
  null
  
)

export default component.exports